import classNames from "classnames";
import React, { useEffect, useState } from "react";

import { Link, useLocation } from "react-router-dom";
import { useStores } from "_common/hooks";

import ModalAbout from "pages/HomeUnAuth/DesktopHome/ModalAbout";
import ModalMBS from "pages/HomeUnAuth/DesktopHome/ModalMBS";
import ModalService from "pages/HomeUnAuth/DesktopHome/ModalService";
import ModalPrivacy from "pages/HomeUnAuth/DesktopHome/ModalPrivacy";

export default function DesktopFooter() {
  const location = useLocation();
  const pathName = location?.pathname;
  const {
    authStore: { general },
  } = useStores();

  const [openModalAbout, setModalAbout] = useState(false);
  const [openModalMBS, setModalMBS] = useState(false);
  const [openModalService, setModalService] = useState(false);
  const [openModalPrivacy, setModalPrivacy] = useState(false);

  return (
    <>
      <footer className="css-4qtnb6 pb-[5rem]">
        <div className="wrapper">
          <div className="col1">
            <div className="logo">
              <span>HNX Trader</span>
            </div>
            <div className="menu-item">
              <div
                onClick={() => setModalPrivacy(true)}
                className="footer-box-span"
              >
                Tuyên bố chính sách bảo mật
              </div>
            </div>
            <div className="menu-item">
              <div
                onClick={() => setModalService(true)}
                className="footer-box-span"
              >
                Điều khoản dịch vụ
              </div>
            </div>
            <div className="menu-item">
              <div
                onClick={() => setModalMBS(true)}
                className="footer-box-span"
              >
                Chứng chỉ MSB
              </div>
            </div>
            <div className="menu-item">
              <div
                onClick={() => setModalAbout(true)}
                className="footer-box-span"
              >
                về chúng tôi
              </div>
            </div>
          </div>
          <div className="copying">
            <span>
              CopyRight © 2017 - 2022 HNX Trader. All Rights Reserved.
            </span>
          </div>
        </div>
      </footer>
      {openModalPrivacy && (
        <ModalPrivacy
          open={openModalPrivacy}
          onClose={() => setModalPrivacy(false)}
        />
      )}
      {openModalAbout && (
        <ModalAbout
          open={openModalAbout}
          onClose={() => setModalAbout(false)}
        />
      )}
      {openModalMBS && (
        <ModalMBS open={openModalMBS} onClose={() => setModalMBS(false)} />
      )}
      {openModalService && (
        <ModalService
          open={openModalService}
          onClose={() => setModalService(false)}
        />
      )}
    </>
  );
}
